module.exports = {"version":"1.13.2","minimumCoreVersion":"4.0.0","protocol":"https","host":"localhost","hostPath":"","port":8080,"title":"Admin Console","footerTitle":"OpenHIM Administration Console","footerPoweredBy":"<a href='http://openhim.org/' target='_blank'>Powered by OpenHIM</a>","loginBanner":"","mediatorLastHeartbeatWarningSeconds":60,"mediatorLastHeartbeatDangerSeconds":120}


//////////////////
// WEBPACK FOOTER
// ./app/config/default.json
// module id = 1338
// module chunks = 0